import React from "react";
import { Link } from "react-router-dom";

/* styles */
import "/styles/modern-normalize.css";
import "/styles/global.css";
import "/styles/components/cover.css";
import "/styles/components/main.css";
import "/styles/components/expandcontent.css";
import "/styles/utility.css";

const DefinitionCard = ({ paragraphId, activeCard, cardData }) => {
  const { word, paragraphId: activeParaId } = activeCard;
  const current = cardData?.[paragraphId]?.[word];

  if (activeParaId !== paragraphId || !current) return null;

  return (
    <div className="expandable-card open">
      {current.image && <img src={current.image} alt={word} loading="lazy" />}
      <p>
        <strong>{word}:</strong> {current.text}
      </p>
      <div className="expandable-card__sourcelinks">
        <a
          href={current.learnMoreLink}
          target="_blank"
          rel="noopener noreferrer"
          className="expandable-card__button"
        >
          Learn More
        </a>
        <Link className="expandable-card__button" to="/reference">
          Reference
        </Link>
      </div>
    </div>
  );
};

export default DefinitionCard;
